getMarketingConsent();

function getMarketingConsent() {
  const emailCheckbox = document.querySelector('#email_checkbox_marketing');
  const smsCheckbox = document.querySelector('#sms_checkbox_marketing');
  const shopUrl = document.querySelector("[data-shopurl]")
  const customerId = emailCheckbox.dataset.customerid;

  const response = fetch(shopUrl.dataset.shopurl + "/apps/spapp/getMareting", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ customerId }),
  }).then(result => result.json()
  ).then(data => {
    emailCheckbox.checked = 'subscribed' === data.email_marketing_consent;
    smsCheckbox.checked = 'subscribed' === data.sms_marketing_consent;
  })
}

// Phone validation function
function validatePhoneNumber(phoneNumber, countryCode) {
  try {
    if (!phoneNumber || phoneNumber.trim() === '') {
      return { isValid: false, error: '' }; // Empty phone is allowed
    }

    // Parse the phone number
    const phoneObj = libphonenumber.parsePhoneNumber(phoneNumber, countryCode);

    if (!phoneObj) {
      return {
        isValid: false,
        error: "Invalid phone number format"
      };
    }

    // Check if the phone number is valid
    if (!phoneObj.isValid()) {
      return {
        isValid: false,
        error: "Please enter a valid phone number"
      };
    }

    // Check if it's a mobile number (optional - remove if you want to allow landlines)
    if (phoneObj.getType() && !['MOBILE', 'FIXED_LINE_OR_MOBILE'].includes(phoneObj.getType())) {
      return {
        isValid: false,
        error: "Please enter a mobile phone number"
      };
    }

    return { isValid: true, error: '', formattedNumber: phoneObj.number };
  } catch (error) {
    return {
      isValid: false,
      error: "Invalid phone number format"
    };
  }
}

// Real-time phone validation
function setupPhoneValidation() {
  const phoneInput = document.querySelector('#phone');
  const countrySelect = document.querySelector('#contry_selector');

  // Use existing .errors-contact.modifyinfos for error display
  const errorContainer = document.querySelector('.errors-contact.modifyinfos');

  function validateAndShowError() {
    const phoneValue = phoneInput.value.trim();
    const countryCode = countrySelect.value;

    if (phoneValue === '') {
      hidePhoneError();
      return;
    }

    const validation = validatePhoneNumber(phoneValue, countryCode);

    if (!validation.isValid) {
      showPhoneError(validation.error);
    } else {
      hidePhoneError();
    }
  }

  function showPhoneError(message) {
    if (errorContainer) {
      errorContainer.textContent = message;
      errorContainer.style.display = 'block';
    }
    phoneInput.classList.add('error');
    // Scroll error into view if needed
    errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hidePhoneError() {
    if (errorContainer) {
      errorContainer.style.display = 'none';
    }
    phoneInput.classList.remove('error');
  }

  // Add event listeners for real-time validation
  phoneInput.addEventListener('input', validateAndShowError);
  phoneInput.addEventListener('blur', validateAndShowError);
  countrySelect.addEventListener('change', validateAndShowError);

  // Return functions for external use
  return {
    showError: showPhoneError,
    hideError: hidePhoneError,
    validate: validateAndShowError
  };
}

function sendMarketingConsent() {
  const emailCheckbox = document.querySelector('#email_checkbox_marketing');
  const smsCheckbox = document.querySelector('#sms_checkbox_marketing');
  const smsMarketingStatut = smsCheckbox.checked ? 'subscribed' : 'unsubscribed';
  const emailMarketingStatut = emailCheckbox.checked ? 'subscribed' : 'unsubscribed';
  const shopUrl = document.querySelector("[data-shopurl]");
  const customerId = emailCheckbox.dataset.customerid;
  const spinner = document.querySelector('#lds-ring');
  const marketing_success = document.querySelector('.marketing_consent_success');
  marketing_success.style.display = "none";

  // Get phone validation functions
  const phoneValidation = window.phoneValidationInstance || {};

  // Enhanced phone validation for SMS consent
  if (smsCheckbox.checked) {
    const phoneInput = document.querySelector('#phone');
    const countrySelect = document.querySelector('#contry_selector');
    const phoneValue = phoneInput.value.trim();

    if (phoneValue === '') {
      if (phoneValidation.showError) {
        phoneValidation.showError("Phone number is required for SMS marketing consent");
      }
      return;
    }

    const validation = validatePhoneNumber(phoneValue, countrySelect.value);
    if (!validation.isValid) {
      if (phoneValidation.showError) {
        phoneValidation.showError(validation.error);
      }
      return;
    }
  }

  // Hide phone errors if validation passes
  if (phoneValidation.hideError) {
    phoneValidation.hideError();
  }

  if (smsCheckbox.dataset.customerphone === '' && smsCheckbox.checked) {
    // This should now be handled by the validation above
    return;
  }
  else {
    spinner.style.display = "inline-block";
    fetch(shopUrl.dataset.shopurl + "/apps/spapp/setMareting", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ customerId, smsMarketingStatut, emailMarketingStatut, hasPhoneNumber: smsCheckbox.dataset.customerphone !== '' }),
    }).then(result => result.json())
      .then(data => {
        spinner.style.display = "none";
        marketing_success.style.display = "block";
        if (phoneValidation.hideError) {
          phoneValidation.hideError();
        }
      })
      .catch(err => {
        spinner.style.display = "none";
      });
  }
}

// Function to lock and protect birthday fields
function lockBirthdayFields() {
  const days = document.querySelector('#select_days');
  const months = document.querySelector('#select_months');
  const years = document.querySelector('#select_years');
  const isLocked = days.hasAttribute('disabled') || months.hasAttribute('disabled') || years.hasAttribute('disabled');

  if (isLocked) {
    const originalValues = {
      day: days.value,
      month: months.value,
      year: years.value
    };

    // Re-apply disabled and readonly attributes
    const enforceLock = () => {
      if (!days.hasAttribute('disabled')) days.setAttribute('disabled', 'disabled');
      if (!days.hasAttribute('readonly')) days.setAttribute('readonly', 'readonly');
      if (!months.hasAttribute('disabled')) months.setAttribute('disabled', 'disabled');
      if (!months.hasAttribute('readonly')) months.setAttribute('readonly', 'readonly');
      if (!years.hasAttribute('disabled')) years.setAttribute('disabled', 'disabled');
      if (!years.hasAttribute('readonly')) years.setAttribute('readonly', 'readonly');

      // Revert any changes to original values
      if (days.value !== originalValues.day) days.value = originalValues.day;
      if (months.value !== originalValues.month) months.value = originalValues.month;
      if (years.value !== originalValues.year) years.value = originalValues.year;
    };

    // Run immediately and every 500ms
    enforceLock();
    const lockInterval = setInterval(enforceLock, 500);

    // Add change event listeners to warn and revert
    [days, months, years].forEach((field) => {
      field.addEventListener('change', (e) => {
        e.preventDefault();
        field.value = originalValues[field.id.replace('select_', '')];
        const errorContainer = document.querySelector('.errors-contact.modifyinfos');
        errorContainer.innerHTML = "Translation missing: en.layout.customer.birthday_locked";
        errorContainer.style.display = "block";
      });
    });

    // Clean up interval on page unload to prevent memory leaks
    window.addEventListener('unload', () => clearInterval(lockInterval));
  }
}

// Function to lock and protect birthday fields
function lockBirthdayFields() {
  const days = document.querySelector('#select_days');
  const months = document.querySelector('#select_months');
  const years = document.querySelector('#select_years');
  const isLocked = days.hasAttribute('disabled') || months.hasAttribute('disabled') || years.hasAttribute('disabled');

  if (isLocked) {
    const originalValues = {
      day: days.value,
      month: months.value,
      year: years.value
    };

    // Re-apply disabled and readonly attributes
    const enforceLock = () => {
      if (!days.hasAttribute('disabled')) days.setAttribute('disabled', 'disabled');
      if (!days.hasAttribute('readonly')) days.setAttribute('readonly', 'readonly');
      if (!months.hasAttribute('disabled')) months.setAttribute('disabled', 'disabled');
      if (!months.hasAttribute('readonly')) months.setAttribute('readonly', 'readonly');
      if (!years.hasAttribute('disabled')) years.setAttribute('disabled', 'disabled');
      if (!years.hasAttribute('readonly')) years.setAttribute('readonly', 'readonly');

      // Revert any changes to original values
      if (days.value !== originalValues.day) days.value = originalValues.day;
      if (months.value !== originalValues.month) months.value = originalValues.month;
      if (years.value !== originalValues.year) years.value = originalValues.year;
    };

    // Run immediately and every 500ms
    enforceLock();
    const lockInterval = setInterval(enforceLock, 500);

    // Add change event listeners to warn and revert
    [days, months, years].forEach((field) => {
      field.addEventListener('change', (e) => {
        e.preventDefault();
        field.value = originalValues[field.id.replace('select_', '')];
        const errorContainer = document.querySelector('.errors-contact.modifyinfos');
        errorContainer.innerHTML = "Translation missing: en.layout.customer.birthday_locked";
        errorContainer.style.display = "block";
      });
    });

    // Clean up interval on page unload to prevent memory leaks
    window.addEventListener('unload', () => clearInterval(lockInterval));
  }
}

// Modified updateCustomer function
// Enhanced updateCustomer function with phone validation
function updateCustomer() {
  const fistName = document.querySelector('#customer_firstname');
  const lastName = document.querySelector('#customer_lastname');
  const phoneInput = document.querySelector('#phone');
  const countrySelect = document.querySelector('#contry_selector');
  const days = document.querySelector('#select_days');
  const months = document.querySelector('#select_months');
  const years = document.querySelector('#select_years');
  const shopUrl = document.querySelector("[data-shopurl]");
  const customerId = fistName.dataset.customerid;
  const modifyInfos_error = document.querySelector('.errors-contact.modifyinfos');
  const spinner = document.querySelector('#lds-ring');
  const modifyInfos_success = document.querySelector('.marketing_consent_success.modifyinfos');
  modifyInfos_success.style.display = "none";

  // Get phone validation functions
  const phoneValidation = window.phoneValidationInstance || {};

  // Basic field validation
  if (fistName.value === '' || lastName.value === '' || !isNaN(lastName.value) || !isNaN(fistName.value)) {
    modifyInfos_error.innerHTML = "Please complete all required entries with valid information";
    modifyInfos_error.style.display = "block";
    return;
  }

  // Phone validation - show error under phone field
  const phoneValue = phoneInput.value.trim();
  if (phoneValue !== '') {
    const validation = validatePhoneNumber(phoneValue, countrySelect.value);
    if (!validation.isValid) {
      // Show error under phone field instead of in general error container
      if (phoneValidation.showError) {
        phoneValidation.showError(validation.error);
      }
      return;
    }
  }

  // Hide phone errors if validation passes
  if (phoneValidation.hideError) {
    phoneValidation.hideError();
  }

  const phone = getCompletePhoneNumber();

  const birthday = years.value && months.value && days.value
    ? years.value + "-" + ("0" + months.value).slice(-2) + "-" + ("0" + days.value).slice(-2)
    : '';

  fetch(shopUrl.dataset.shopurl + "/apps/spapp/updatecustomer", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ customerId, fistName: fistName.value, lastName: lastName.value, phone: phone, birthday }),
  }).then(result => result.json())
    .then(data => {
      // Only update fields if we have valid data, otherwise keep current values
      if (data?.customerUpdate?.customer?.firstName) {
        fistName.value = data.customerUpdate.customer.firstName;
      }
      if (data?.customerUpdate?.customer?.lastName) {
        lastName.value = data.customerUpdate.customer.lastName;
}

      // Disable and lock birthday fields if birthday is set
      // Disable and lock birthday fields if birthday is set
      if (data?.metafieldsSet?.metafields[0]?.key === 'birthday') {
        days.setAttribute('disabled', 'disabled');
        months.setAttribute('disabled', 'disabled');
        years.setAttribute('disabled', 'disabled');
        days.setAttribute('readonly', 'readonly');
        months.setAttribute('readonly', 'readonly');
        years.setAttribute('readonly', 'readonly');
        lockBirthdayFields(); // Apply dynamic locking
      } else {
        days.value = "";
        months.value = "";
        years.value = "";
      }

      if (data?.customerUpdate?.userErrors[0]?.field[0] === 'phone') {
        // Show phone error under phone field
        if (phoneValidation.showError) {
          phoneValidation.showError(data?.customerUpdate?.userErrors[0]?.message);
        }
        throw data?.customerUpdate?.userErrors[0]?.message;
      }
       // UPDATE: Update the data-customerphone attribute with the new phone number
      const smsCheckbox = document.querySelector('#sms_checkbox_marketing');
      if (smsCheckbox && phone) {
        smsCheckbox.setAttribute('data-customerphone', phone);
      }

      // UPDATE: Also update the phone input's data-customerphone attribute for consistency
      if (phoneInput && phone) {
        phoneInput.setAttribute('data-customerphone', phone);
      }

      spinner.style.display = "none";
      modifyInfos_error.style.display = "none";
      modifyInfos_success.style.display = "block";

      // Hide phone errors on success
      if (phoneValidation.hideError) {
        phoneValidation.hideError();
      }
    })
    .catch(err => {
      spinner.style.display = "none";

      // Check if it's a phone error - show under phone field
      if (err && err.toString().toLowerCase().includes('phone')) {
        if (phoneValidation.showError) {
          phoneValidation.showError(err?.error || err || "Please enter a valid phone number");
        }
      } else {
        // Show other errors in general error container
        modifyInfos_error.innerHTML = err?.error || err || "Translation missing: en.layout.customer.update_failed";
        modifyInfos_error.style.display = "block";
      }
    });
}

// Initialize locking and phone validation on page load
document.addEventListener('DOMContentLoaded', () => {
  lockBirthdayFields();

  // Setup phone validation and store instance globally for access by other functions
  window.phoneValidationInstance = setupPhoneValidation();
});

// Keep the rest of the file unchanged

//it returns the complete phone number dial_code + number
function getCompletePhoneNumber() {
  let countrySelect = document.querySelector('#contry_selector');
  let inputPhone = document.querySelector('#phone');
  let country = countrySelect.value;

  if (inputPhone.value.length > 0) {
    return libphonenumber.parsePhoneNumber(inputPhone.value, country)?.number;
  } else {
    return '';
  }
}

function displayPhoneNumber() {
  let countrySelect = document.querySelector('#contry_selector');
  let inputPhone = document.querySelector('#phone');

  const phonenumber = inputPhone.getAttribute('data-customerphone');
  if (phonenumber && phonenumber.length > 0) {
    const phoneObj = libphonenumber.parsePhoneNumberFromString(phonenumber);
    inputPhone.value = phoneObj?.nationalNumber;
    countrySelect.value = phoneObj?.country;
  }
}

//display the phone number if exist
displayPhoneNumber();